import Vue from 'vue'
import store from '@/store/index'
import orderBy from 'lodash.orderby'
import car_types from '@/components/fleet/car_types.json'
;('use strict')

let extra_types = {
  refrigerated: 'extra-refrigerated',
  frozen: 'extra-frozen',
  dangerous_goods: 'extra-dangerous-goods',
  loading_bridge_required: 'extra-loading-bridge-required',
  no_stacking: 'extra-no-stackable',
  breakable: 'extra-breakable',
  fragile: 'extra-fragile',
  food_donation: 'extra-food-donation'
}

let ordered_states = [
  'new',
  'cancelled',
  'expired',
  'accepted',
  'onwaytopickup',
  'nearpickup',
  'arrivedpickup',
  'loading',
  'loaded',
  'onwaytodelivery',
  'neardelivery',
  'arriveddelivery',
  'unloading',
  'unloaded',
  'delivered',
  'finalised',
  'invoicereceived',
  'paid'
]

// https://github.com/MitrophD/vue-phone-input/blob/master/src/VuePhoneInput/index.vue
let country_codes = [
    { code: 'AT', name: 'Austria (Österreich)', dialCode: '+43', example: '0664 123456' },
    { code: 'BE', name: 'Belgium (België)', dialCode: '+32', example: '0470 12 34 56' },
    { code: 'BG', name: 'Bulgaria (България)', dialCode: '+359', example: '048 123 456' },
    { code: 'HR', name: 'Croatia (Hrvatska)', dialCode: '+385', example: '091 234 5678' },
    { code: 'CY', name: 'Cyprus (Κύπρος)', dialCode: '+357', example: '96 123456' },
    { code: 'CZ', name: 'Czech Republic (Česká republika)', dialCode: '+420', example: '601 123 456' },
    { code: 'DK', name: 'Denmark (Danmark)', dialCode: '+45', example: '20 12 34 56' },
    { code: 'EE', name: 'Estonia (Eesti)', dialCode: '+372', example: '5123 4567' },
    { code: 'FI', name: 'Finland (Suomi)', dialCode: '+358', example: '041 2345678' },
    { code: 'FR', name: 'France', dialCode: '+33', example: '06 12 34 56 78' },
    { code: 'DE', name: 'Germany (Deutschland)', dialCode: '+49', example: '01512 3456789' },
    { code: 'GR', name: 'Greece (Ελλάδα)', dialCode: '+30', example: '691 234 5678' },
    { code: 'HU', name: 'Hungary (Magyarország)', dialCode: '+36', example: '(20) 123 4567' },
    { code: 'IE', name: 'Ireland', dialCode: '+353', example: '085 012 3456' },
    { code: 'IT', name: 'Italy (Italia)', dialCode: '+39', example: '312 345 6789' },
    { code: 'LV', name: 'Latvia (Latvija)', dialCode: '+371', example: '21 234 567' },
    { code: 'LT', name: 'Lithuania (Lietuva)', dialCode: '+370', example: '(8-612) 34567' },
    { code: 'LU', name: 'Luxembourg', dialCode: '+352', example: '628 123 456' },
    { code: 'MK', name: 'Macedonia (FYROM) (Македонија)', dialCode: '+389', example: '072 345 678' },
    { code: 'MT', name: 'Malta', dialCode: '+356', example: '9696 1234' },
    { code: 'NL', name: 'Netherlands (Nederland)', dialCode: '+31', example: '06 12345678' },
    { code: 'PL', name: 'Poland (Polska)', dialCode: '+48', example: '512 345 678' },
    { code: 'PT', name: 'Portugal', dialCode: '+351', example: '912 345 678' },
    { code: 'RO', name: 'Romania (România)', dialCode: '+40', example: '0712 345 678' },
    { code: 'SK', name: 'Slovakia (Slovensko)', dialCode: '+421', example: '0912 123 456' },
    { code: 'ES', name: 'Spain (España)', dialCode: '+34', example: '612 34 56 78' },
    { code: 'SE', name: 'Sweden (Sverige)', dialCode: '+46', example: '070-123 45 67' },
    { code: 'GB', name: 'United Kingdom', dialCode: '+44', example: '07400 123456' }
]

Vue.mixin({
  methods: {
    /**
     * Get the car type
     *
     * @param {Number} type_id The type id of a car
     */
    getCarType: function(type_id) {
      return car_types.find(car => {
        return car.id === type_id
      }).vue_type
    },

    /**
     * Get the country objects keyed by dialcode     
     */
    getCountriesByDialCode() {
      return orderBy(country_codes, ['dialCode'], ['asc'])
    },

    /**
     * Get the country objects keyed by 2 char country code
     */
    getCountriesByCountryCode() {
      return orderBy(country_codes, ['code'], ['asc'])
    },

    /**
     * Get the slug of the extra type
     *
     * @param {Number} type_id The type id of a car
     */
    getExtraSlug: function(type_id) {
      if (type_id.includes('refrigerated')) type_id = 'refrigerated'
      if (type_id.includes('frozen')) type_id = 'frozen'
      return type_id
    },

    /**
     * Get the car type
     *
     * @param {Number} type_id The type id of a car
     */
    getExtraType: function(type_id) {
      return extra_types[type_id]
    },

    /**
     * Get the vengo represented image
     *
     * @param {String} url The image url
     */
    getImage: function(url) {
      return `${process.env.VUE_APP_API_URL}/${url}?access_token=${store.getters.access_token}`
    },

    /**
     * Get an array of all order states
     */
    getOrderStates: function() {
      return ordered_states
    },

    /**
     * Order an array of objects by the values of a matching array
     *
     * @param {Array} array The initial array of objects
     * @param {String} order the order in witch the array should return
     * @param {String, Number} key the key of the object to match
     */
    mapStateOrder: function(array, key, o) {
      let order = this.getOrderStates()
      array.sort(function(a, b) {
        var A = a[key].state,
          B = b[key].state
        console.log(B)
        if (o === 'asc') {
          if (order.indexOf(A) > order.indexOf(B)) {
            return 1
          } else {
            return -1
          }
        } else {
          if (order.indexOf(A) < order.indexOf(B)) {
            return 1
          } else {
            return -1
          }
        }
      })

      return array
    },

    /* 
    | --------------
    | Calculate the long lat range 
    | --------------
    */
    getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
      var R = 6371
      var dLat = this.deg2rad(lat2 - lat1)
      var dLon = this.deg2rad(lon2 - lon1)
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.deg2rad(lat1)) *
          Math.cos(this.deg2rad(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2)
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      var d = R * c
      return d
    },

    /* 
    | --------------
    | calculate deg to radius
    | --------------
    */
    deg2rad(deg) {
      return deg * (Math.PI / 180)
    },

    getMarker(type) {
      if (type === 'orange')
        return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCA5MCA5MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBpZD0iSWNvbi9waW4vZGVmYXVsdC9vcmFuZ2UiPjxwYXRoIGlkPSJDb21iaW5lZCBTaGFwZSIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMCAzNUMxMCAxNS43MDEgMjUuNzAxIDAgNDUgMEM2NC4yOTkgMCA4MCAxNS43MDEgODAgMzVDODAgNjMuODYyIDQ3Ljg3NCA4OC40NjIgNDYuNTA3IDg5LjQ5NUM0Ni4wNjIgODkuODMyIDQ1LjUzIDkwIDQ1IDkwQzQ0LjQ3IDkwIDQzLjkzOCA4OS44MzIgNDMuNDkzIDg5LjQ5NUM0Mi4xMjYgODguNDYyIDEwIDYzLjg2MiAxMCAzNVpNMzAgMzVDMzAgNDMuMjcxIDM2LjcyOSA1MCA0NSA1MEM1My4yNzEgNTAgNjAgNDMuMjcxIDYwIDM1QzYwIDI2LjcyOSA1My4yNzEgMjAgNDUgMjBDMzYuNzI5IDIwIDMwIDI2LjcyOSAzMCAzNVoiIGZpbGw9IiNGMjY0NEEiLz48L2c+PC9zdmc+'
      if (type === 'green')
        return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCA5MCA5MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBpZD0iSWNvbi9waW4vZGVmYXVsdC9ncmVlbiI+PHBhdGggaWQ9IkNvbWJpbmVkIFNoYXBlIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEwIDM1QzEwIDE1LjcwMSAyNS43MDEgMCA0NSAwQzY0LjI5OSAwIDgwIDE1LjcwMSA4MCAzNUM4MCA2My44NjIgNDcuODc0IDg4LjQ2MiA0Ni41MDcgODkuNDk1QzQ2LjA2MiA4OS44MzIgNDUuNTMgOTAgNDUgOTBDNDQuNDcgOTAgNDMuOTM4IDg5LjgzMiA0My40OTMgODkuNDk1QzQyLjEyNiA4OC40NjIgMTAgNjMuODYyIDEwIDM1Wk0zMCAzNUMzMCA0My4yNzEgMzYuNzI5IDUwIDQ1IDUwQzUzLjI3MSA1MCA2MCA0My4yNzEgNjAgMzVDNjAgMjYuNzI5IDUzLjI3MSAyMCA0NSAyMEMzNi43MjkgMjAgMzAgMjYuNzI5IDMwIDM1WiIgZmlsbD0iIzhBQzRBQiIvPjwvZz48L3N2Zz4='
    },

    /* 
    | --------------
    | check if a given state is after another state
    | --------------
    */
    isStateAfter(stateToCheck, stateToCheckAgainst) {
      return ordered_states.indexOf(stateToCheck) > ordered_states.indexOf(stateToCheckAgainst)
    },

    /* 
    | --------------
    | generate a UID https://www.w3resource.com/javascript-exercises/javascript-math-exercise-23.php
    | --------------
    */
    create_UUID() {
      let dt = new Date().getTime()
      let uuid = 'DISPxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (dt + Math.random() * 16) % 16 | 0
        dt = Math.floor(dt / 16)
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16)
      })
      return uuid
    },

    normalizeGmapAddress(location) {
      var address = {
        zip: '',
        street: '',
        city: '',
        country: '',
        number: '',
        box: ''
      }
      var components = location.address_components

      for (var i = 0, component; i < components.length; i++) {
        component = components[i]
        if (component.types[0] === 'route') {
          address.street = component['long_name']
        } else if (component.types[0] === 'street_number') {
          address.number = component['long_name']
        } else if (component.types[0] === 'locality') {
          address.city = component['long_name']
        } else if (component.types[0] === 'country') {
          address.country = component['short_name']
        } else if (component.types[0] === 'postal_code') {
          address.zip = component['long_name']
        } else if (component.types[0] === 'premise' && !address.number) {
          address.number = component['long_name']
        } else if (component.types[0] === '"postal_town"' && !address.city) {
          address.city = component['long_name']
        } else if (component.types[0] === '"post_box"') {
          address.box = component['long_name']
        }
      }
      address.lat = location.geometry.location.lat()
      address.lng = location.geometry.location.lng()

      address.formatted = location.formatted_address

      return address
    },

    /**
     * check if two unix timestamps are on the same day
     *
     * @param {String} encoded
     * @param {String} base64decode
     */
    isSameDay(PUtime, DOtime, tz) {
        let PU = this.$moment.unix(parseInt(PUtime)).tz(tz);  
        let DO = this.$moment.unix(parseInt(DOtime)).tz(tz);

        return PU.isSame(DO, 'day');
    },

    calcStars(ratings, stars) {      
        return Math.round(stars/ratings);
    },

    checkTime(PUtime, DOtime, tz) {
      let PU = this.$moment.unix(parseInt(PUtime)).tz(tz).format('HH:mm');  
      let DO = this.$moment.unix(parseInt(DOtime)).tz(tz).format('HH:mm');

      if (PU == "08:00" && DO == "17:00") { //workday
          return 'workday'
      } 
      else if (PU == "17:00" && DO == "22:00") { //evening
          return 'evening'
      } 
      else if (PU == "00:00" && DO == "23:55") { //op afspraak
          return 'arrangement'
      } 
      else if (PU == "07:30" && DO == "12:00") { //morning
          return 'morning'
      } 
      else if (PU == "12:00" && DO == "17:00") { //afternoon
          return 'afternoon'
      } 
      else {
          return 'between'
      }    
    },

    /**
     * Decode a vengo route
     *
     * @param {String} encoded
     * @param {String} base64decode
     */
    decodeRoute: function(encoded, base64decode) {
      if (base64decode) {
        encoded = window.atob(encoded)
      }
      var points = []
      var index = 0
      var len = encoded.length
      var lat = 0
      var lng = 0
      while (index < len) {
        var b
        var shift = 0
        var result = 0
        do {
          b = encoded.charAt(index++).charCodeAt(0) - 63
          result |= (b & 0x1f) << shift
          shift += 5
        } while (b >= 0x20)

        var dlat = (result & 1) !== 0 ? ~(result >> 1) : result >> 1
        lat += dlat
        shift = 0
        result = 0
        do {
          b = encoded.charAt(index++).charCodeAt(0) - 63
          result |= (b & 0x1f) << shift
          shift += 5
        } while (b >= 0x20)
        var dlng = (result & 1) !== 0 ? ~(result >> 1) : result >> 1
        lng += dlng

        points.push({ lat: lat / 1e5, lng: lng / 1e5 })
      }
      return points
    }
  }
})
